'use strict'

import css from './wizard-step.styles.scss'
import template from './wizard-step.template.pug'

export class WizardStepController {}

export const umsWizardStep = {
  template: template({ css }),
  transclude: true,
  bindings: {
    icon: '@',
    title: '@',
  },
  controller: WizardStepController,
}



// WEBPACK FOOTER //
// ./app/shared/components/wizard-step/wizard-step.component.js